(() => {
  let frame;
  let lastWidth = 0;
  function align() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const rows = new Map();
    grid.querySelectorAll(':scope > .grid__item').forEach(item => {
      const title = item.querySelector('.card > .card__content > .card__information .card__heading');
      if (!title || !item.getClientRects().length) return;
      title.style.minHeight = '';
      const top = Math.round(item.getBoundingClientRect().top + window.scrollY);
      const row = rows.get(top) || [];
      row.push(title);
      rows.set(top, row);
    });
    rows.forEach(titles => {
      const height = Math.ceil(Math.max(...titles.map(title => title.getBoundingClientRect().height)));
      titles.forEach(title => title.style.minHeight = height + 'px');
    });
  }
  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(align);
  }
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.fonts?.ready.then(schedule);
  const main = document.getElementById('MainContent');
  if (main) {
    new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
    new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      if (width !== lastWidth) {
        lastWidth = width;
        schedule();
      }
    }).observe(main);
  }
  schedule();
})();
